/**
 * Fetch with timeout covering headers and body read (e.g. response.json()).
 */
export async function fetchJsonWithTimeout(fetchFn, url, options, timeoutMs) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetchFn(url, { ...options, signal: controller.signal });
    let data = null;
    try {
      data = await res.json();
    } catch (err) {
      if (err?.name === "AbortError") {
        throw err;
      }
      data = null;
    }
    return { res, data };
  } finally {
    clearTimeout(timer);
  }
}
